<template>
  <div class="md-layout regions-item">
    <div class="md-layout-item md-size-25" v-for="region in regions" :key="region">
      <stats-card header-color="blue" class="regions-card" :footer="false">
        <template slot="header">
          <div class="card-icon">
            <div class="number-sub">{{region}}</div>
          </div>
          <p class="category" v-for="crop in cropsRegions" :key="crop"><strong>{{crop}}:</strong> {{getZoneValue(crop, region)}} <span class="unit">{{getMarginUnit()}}</span></p>
        </template>
      </stats-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StatsCard from '@/components/Cards/StatsCard'

export default {
  name: "regions-cards",
  props: ['optionSelected'],
  components: { StatsCard },
  computed: {
    ...mapState(['regions','cropsRegions','data','headers'])
  },
  methods: {
    getZoneValue(crop, region) {
      let row = this.getDataRow({ cropSelected: crop, regionSelected: region });
      let value = this.getMarginValue(row);

      if (value === null || value === undefined || value === '') {
        return '';
      }

      // Convertimos a número y formateamos con coma decimal
      const number = Number(value);

      if (isNaN(number)) {
        return value;
      }

      // Si es entero, devolver sin decimales
      if (Number.isInteger(number)) {
        return number.toString().replace('.', ',');
      }

      // Si tiene decimales, mostrar solo 1
      return number
        .toFixed(1)
        .replace('.', ',');
    },
    getMarginUnit() {
      switch(this.optionSelected){
      case 'Margen Bruto': return 'USD/ha';
      case 'Margen Neto': return 'USD/ha';
      case 'Rentabilidad': return '%';
      case 'Rinde de Equilibrio': return 'qq/ha';
      case 'Precio de Equilibrio': return 'USD/t';
      default: return 'n/a';
      }
    },
    getMarginValue(row) {
      switch(this.optionSelected){
      case 'Margen Bruto': return row['margen_bruto'];
      case 'Margen Neto': return row['margen_neto'];
      case 'Rentabilidad': return row['renta'];
      case 'Rinde de Equilibrio': return row['rinde_equilibrio'];
      case 'Precio de Equilibrio': return row['precio_equilibrio'];
      default: return 'n/a';
      }
    },
    getDataRow(payload) {
      let response = [];
      for (let key in this.data)
        if (this.data[key][0] == payload.regionSelected  && this.data[key][1] == payload.cropSelected ) {
          let row = this.data[key];
          for (let index in row){
            response[this.headers[index]] = row[index];
          }
        }
      return response;
    },
  },

}
</script>

<style scoped>

</style>
